(function () {
  'use strict';
  var STAGGER_MS = 90;

  function reveal(el, delay) {
    if (delay) el.style.transitionDelay = delay + 'ms';
    el.classList.add('is-visible');
  }

  /* Reduced-motion: skip all animation */
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  /* No IntersectionObserver support: reveal all immediately */
  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('.rly-reveal').forEach(function (el) { reveal(el, 0); });
    return;
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      if (el.classList.contains('rly-reveal-group')) {
        /* Stagger all .rly-reveal descendants */
        var children = Array.from(el.querySelectorAll('.rly-reveal'));
        children.forEach(function (child, i) { reveal(child, i * STAGGER_MS); });
      } else {
        reveal(el, 0);
      }
      io.unobserve(el);
    });
  }, { threshold: 0.08, rootMargin: '0px 0px -48px 0px' });

  /* Observe groups and standalone reveals (skip children inside a group) */
  document.querySelectorAll('.rly-reveal, .rly-reveal-group').forEach(function (el) {
    if (el.classList.contains('rly-reveal') && el.closest('.rly-reveal-group')) return;
    io.observe(el);
  });
})();
